import styled from 'styled-components'
import { DolaThemeProps } from '../../../styles/types'

interface OverlayProps extends DolaThemeProps {
  closing: boolean
  visible: boolean
}

const Overlay = styled.div<OverlayProps>`
  background-color: ${({ dolaTheme }) =>
    dolaTheme === 'light'
      ? 'rgba(56, 62, 86, 0.75)'
      : 'rgba(0, 0, 0, 0.75)'};
  display: block;
  height: ${({ visible }) => (visible ? '100%' : 0)};
  overflow: hidden;
  pointer-events: ${({ visible }) => (visible ? 'initial' : 'none')};
  opacity: ${({ closing, visible }) => (closing ? 0 : visible ? 1 : 0)};
  transition: opacity 0.4s ease ${({ closing }) => (closing ? '0.2s' : '')};
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10000;
  ${({ visible }) => (visible ? 'position: fixed;' : '')}
`

export default Overlay
